/**
 * Google Maps API Initialization
 * 
 * This file initializes the Google Maps API with Places Library.
 * It's processed by Vite, so import.meta.env values are replaced at build time.
 */

// Initialize Google Maps callback
window.initMap = function() {
  console.log('✅ Google Maps API loaded');
  window.googleMapsLoaded = true;
  window.dispatchEvent(new Event('google-maps-loaded'));
};

// Error callback for Google Maps API
window.gm_authFailure = function() {
  const currentOrigin = window.location.origin;
  const errorMsg = 'Google Maps API authentication failed. This usually means:\n' +
    '1. Your API key is blocked or restricted\n' +
    '2. The Maps JavaScript API is not enabled for this key\n' +
    '3. HTTP referrer restrictions don\'t match this domain (' + currentOrigin + ')\n' +
    '4. IP restrictions don\'t match your current IP\n\n' +
    'Please check your API key configuration in Google Cloud Console:\n' +
    'https://console.cloud.google.com/apis/credentials\n\n' +
    'Make sure to:\n' +
    '- Enable "Maps JavaScript API" for this key\n' +
    '- Add HTTP referrer: ' + currentOrigin + '/*\n' +
    '- Remove IP restrictions (or add your IP)';
  console.error('❌', errorMsg);
  window.googleMapsError = errorMsg;
  window.dispatchEvent(new CustomEvent('google-maps-error', { 
    detail: { message: errorMsg } 
  }));
};

// Catch unhandled Google Maps errors (including ApiTargetBlockedMapError)
window.addEventListener('error', function(event) {
  if (event.message && (
    event.message.includes('ApiTargetBlockedMapError') || 
    event.message.includes('api_target_blocked') ||
    event.error?.name === 'ApiTargetBlockedMapError'
  )) {
    const currentOrigin = window.location.origin;
    const errorMsg = 'Google Maps API is blocked (ApiTargetBlockedMapError).\n\n' +
      'This usually means your API key has restrictions that don\'t match this domain.\n\n' +
      'Fix in Google Cloud Console:\n' +
      '1. Go to: https://console.cloud.google.com/apis/credentials\n' +
      '2. Click your API key\n' +
      '3. Under "Application restrictions":\n' +
      '   - Select "HTTP referrers (web sites)"\n' +
      '   - Add: ' + currentOrigin + '/*\n' +
      '   - Add: ' + currentOrigin.replace('https://', 'http://') + '/* (for dev)\n' +
      '4. Under "API restrictions":\n' +
      '   - Ensure "Maps JavaScript API" is enabled\n' +
      '   - Ensure "Places API (New)" is enabled\n' +
      '5. Remove IP restrictions (or add your current IP)';
    console.error('❌', errorMsg);
    window.googleMapsError = errorMsg;
    window.dispatchEvent(new CustomEvent('google-maps-error', { 
      detail: { message: errorMsg } 
    }));
  }
}, true);

// Load Google Maps API dynamically with environment variable
// Only load once, even if this script runs multiple times
if (!window.googleMapsScriptAdded) {
  window.googleMapsScriptAdded = true;
  
  // Get API key (replaced by Vite at build time)
  const apiKey = import.meta.env.VITE_GOOGLE_PLACES_API_KEY;
  if (!apiKey) {
    const errorMsg = 'VITE_GOOGLE_PLACES_API_KEY is not set. Google Maps will not load.';
    console.error('⚠️', errorMsg);
    console.error('Please add VITE_GOOGLE_PLACES_API_KEY to your environment variables');
    window.googleMapsError = errorMsg;
    window.dispatchEvent(new CustomEvent('google-maps-error', { 
      detail: { message: errorMsg } 
    }));
  } else {
    // Check if script already exists in DOM
    const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initMap&loading=async&v=weekly`;
      script.async = true;
      script.defer = true;
      script.id = 'google-maps-script';
      
      // Handle script load errors
      script.onerror = function() {
        const errorMsg = 'Failed to load Google Maps API script. Check your network connection and API key.';
        console.error('❌', errorMsg);
        window.googleMapsError = errorMsg;
        window.dispatchEvent(new CustomEvent('google-maps-error', { 
          detail: { message: errorMsg } 
        }));
      };
      
      document.head.appendChild(script);
      console.log('📍 Loading Google Maps API...');
    } else {
      console.log('📍 Google Maps API script already exists');
    }
  }
}

